module.exports = __webpack_public_path__ + "images/may14-homeBtest4.jpg";